import { Search } from 'lucide-react';

import { useCommandPalette } from './useCommandPalette';

/**
 * Search trigger button in the header
 * Opens the command palette when clicked
 */
const CommandSearch = () => {
  const { openPalette } = useCommandPalette();

  return (
    <button
      onClick={openPalette}
      aria-label="Search"
      className="flex items-center gap-2 rounded-lg
        bg-stone-200/60 hover:bg-stone-300/60 dark:bg-white/10 dark:hover:bg-white/20
        border border-stone-300 hover:border-stone-400 dark:border-white/20 dark:hover:border-white/30
        text-stone-600 hover:text-stone-800 dark:text-amber-100/70 dark:hover:text-amber-100
        transition-all duration-200 cursor-pointer
        focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-500
        h-9 w-9 justify-center p-0
        sm:h-auto sm:w-auto sm:justify-start sm:px-3 sm:py-1.5 sm:min-w-[200px] md:min-w-[280px]
        admin-touch:min-h-[44px] admin-touch:min-w-[44px]"
    >
      <Search className="h-4 w-4 flex-shrink-0" />
      <span className="text-sm hidden sm:inline">Search...</span>
      <kbd className="ml-auto hidden sm:inline-flex h-5 items-center gap-1 rounded border border-stone-300 dark:border-white/20 bg-stone-100 dark:bg-white/5 px-1.5 font-mono text-[10px] font-medium text-stone-500 dark:text-amber-200/60">
        <span className="text-xs">&#8984;</span>K
      </kbd>
    </button>
  );
};

export default CommandSearch;
